import { ROUTES } from "@lhd/constants";

export const SALARY_WORKER_FILTER_ROUTE_PATTERNS = [
  /^\/annual_salary_summaries\/\d{4}\/staff_tax_sheets$/,
  /^\/annual_salary_summaries\/\d{4}\/provisions$/,
  /^\/annual_salary_summaries\/\d{4}\/deductions$/,
  /^\/annual_salary_summaries\/\d{4}\/works$/,
  /^\/annual_salary_summaries\/\d{4}\/expenses$/,
  /^\/annual_salary_summaries\/\d{4}\/transfers$/,
  /^\/annual_salary_summaries\/\d{4}\/arrangements$/,
  /^\/annual_salary_summaries\/\d{4}\/salary_sheets$/,
  /^\/annual_salary_summaries\/\d{4}\/payment_sheets$/,
  /^\/annual_salary_summaries(\/\d{4})?\/salary_ledgers$/,
];

export const isSalaryWorkerFilterRoute = (pathname: string) =>
  SALARY_WORKER_FILTER_ROUTE_PATTERNS.some((pattern) => pattern.test(pathname));

export const isSalaryWorkerFilterChangeSizeRoute = (pathname: string) =>
  isSalaryWorkerFilterRoute(pathname) ||
  pathname.includes(ROUTES.WORKERS_CREATE) ||
  pathname.includes(`/${ROUTES.WORKERS}`);
